import { render, staticRenderFns } from "./FeatureCardHandler.vue?vue&type=template&id=274ec2cb&scoped=true&"
import script from "./FeatureCardHandler.vue?vue&type=script&lang=js&"
export * from "./FeatureCardHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274ec2cb",
  null
  
)

export default component.exports